/**
 * CC Related Products slider
 *
 * Looping variant of the stock Trade SliderComponent, used only by the
 * related-products carousel (snippets/cc-related-products.liquid).
 *
 * - Next on the last page scrolls back to the first card.
 * - Previous on the first page scrolls to the last page.
 * - Prev/next are never disabled.
 *
 * No autoplay. Scrolling itself is the browser's scroll-snap, so
 * prefers-reduced-motion is honored through `.slider { scroll-behavior }`
 * in component-slider.css. Deliberately scoped to its own tag name so the
 * collection sliders and product media gallery keep the stock behaviour.
 */
class CCRelatedSlider extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;

    if (!this.slider || !this.nextButton) return;

    // The base constructor already ran one update() with looping off, which
    // may have disabled the previous button at scroll position 0.
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
  }

  onButtonClick(event) {
    if (!this.slider) return;

    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
    // Sub-pixel scroll positions can leave scrollLeft a fraction short of the
    // true edge, so compare with a 1px tolerance.
    const atStart = this.slider.scrollLeft <= 1;
    const atEnd = this.slider.scrollLeft >= maxScrollLeft - 1;

    if (event.currentTarget.name === 'next' && atEnd) {
      event.preventDefault();
      this.setSlidePosition(0);
      return;
    }

    if (event.currentTarget.name === 'previous' && atStart) {
      event.preventDefault();
      this.setSlidePosition(maxScrollLeft);
      return;
    }

    super.onButtonClick(event);
  }
}

customElements.define('cc-related-slider', CCRelatedSlider);
